import { ReferralEndpoint } from './endpoints'
import { ReferralCode } from './types'
import { client } from '@/api/client'

export const sendReferralCode = async (
  payload: ReferralCode['Payload'],
): Promise<ReferralCode['Response']> => {
  const res = await client.post(ReferralEndpoint, payload)
  return res.data.data
}
